<div class="shared-page-header-segment-container multi-line-tabs">
  <div
    [ngClass]="{'shared-page-header-segments-modal': isModal, 'shared-page-header-segments': !isModal}"
    appHorizontalScroll>

    @if (stores.length > 0) {
      @for (store of stores; track store.storeId) {
        <div
          (click)="onStoreChange(store)"
          [style.max-width]="isModal ? getTabMaxWidth(): ''"
          class="tab">
          <app-shared-button
            [colour]="'clear'"
            [header]="true"
            [ngClass]="{'segment-button-modal': isModal, 'segment-button': !isModal}"
            [selected]="store === selectedStore">
            <span class="label-span">
              {{ store.name }}
              @if (showFreshnessIndicator) {
                <app-shared-freshness-indicator-container
                  [currentStore]="store"
                  [dataType]="dataTimeStampKey[0]"
                  class="freshness-button">
                </app-shared-freshness-indicator-container>
              }
            </span>
          </app-shared-button>
        </div>
      }
    }

    @if (stores.length < 1) {
      <div class="tab">
        <app-shared-button
          [colour]="'clear'"
          [disabled]="true"
          [header]="true"
          [ngClass]="{'segment-button-modal': isModal, 'segment-button': !isModal}">
          <span class="label-span">No Stores Available</span>
        </app-shared-button>
      </div>
    }
  </div>

</div>
